module.exports = __webpack_public_path__ + "img/wdkYBTNfFW1634106816405.dabeff64.jpg";